import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { FormControl, MenuItem, Select, useMediaQuery } from '@mui/material';
import toast from 'react-hot-toast';

import { ContainerButtonPlay } from '../../Utils/Button';
import { IUserFromStorage } from '../../Interfaces/IUser';
import { getMiniCurso } from '../../Services/MiniCurso';
import { IMiniCursoFit12Response, IMiniCursoResponse } from '../../Interfaces/IMiniCurso';
import Loading from '../../Utils/Loading';
import VideoPlayer from '../../Components/VideoPlayer/VideoPlayer';
// import MiniCursoVeroPC from '../../Components/MiniCurso/MiniCursoVeroPC';

import { grayPlayButton } from '../../Shared/Images';
// import TouchAppIcon from '@mui/icons-material/TouchApp';
import atrasIcon from '../../Shared/Images/atras-icon.png';
// import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
// import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
// import ScrollToBottomFab from '../../Components/FAB/ScrollToBottomFab';
import MiniCursoMenuFab from '../../Components/FAB/MiniCursoMenuFab';
import MiniCursoMenu from '../../Components/MiniCurso/MiniCursoMenu';
import Fit12PagePC from '../../Components/MiniCurso/Fit12PagePC';

import '../Styles/Fit12Page.css';


interface Props {
  productId: number;
}

const Fit12Page = ({ productId }: Props) => {

  const [mostrarVideo, setMostrarVideo] = useState<boolean>(false);
  const [currentWeek, setCurrentWeek] = useState<IMiniCursoResponse[]>();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [weeks, setWeeks] = useState<IMiniCursoFit12Response[]>([]);
  const [weekPosition, setWeekPosition] = useState<number>(0);
  const [dataMiniCurso, setDataMiniCurso] = useState<IMiniCursoResponse>();
  const [currentPosition, setCurrentPosition] = useState<number>(0);
  const [isOpenMenu, setIsOpenMenu] = useState<boolean>(false);

  const user : IUserFromStorage = JSON.parse(localStorage.getItem("user")) || '';
  const matches = useMediaQuery('(max-width: 650px)');
  const navigate = useNavigate();
  
  useEffect(() => {
    getMiniCurso({
      UsuarioTestAsesoriaID: user.usuarioTestAsesoriaID,
      TipoPagoID: productId ?? 26,
      Agrupado: true
    })
      .then(res => {
        if(res.data.data.length > 0) {
          setWeeks(res.data.data);
        }
      })
      .catch(err => {
        toast.error(`Algo salió mal, inténtelo de nuevo más tarde ${err}`);
      })
      .finally(() => {
        setIsLoading(false);
      })

  }, [])

  useEffect(() => {
    if( weeks && weeks.length > 0 ) {
      setCurrentWeek(weeks[weekPosition].videos);
      setCurrentPosition(0);
      setMostrarVideo(false);
    }
  }, [weeks, weekPosition])

  useEffect(() => {
    if (currentWeek && currentWeek.length > 0) {
      setDataMiniCurso({
        descripcion:      currentWeek[currentPosition].descripcion,
        miniCursoVideoID: currentWeek[currentPosition].miniCursoVideoID,
        titulo:           currentWeek[currentPosition].titulo,
        urlVimeoHLS:      currentWeek[currentPosition].urlVimeoHLS,
        portada:          currentWeek[currentPosition].portada,
        orden:            currentWeek[currentPosition].orden,
      });
    }
  }, [currentWeek, currentPosition])

  // function retrocederVideo () {
  //   if(currentPosition !== 0) {
  //     if(currentWeek[currentPosition - 1]) {
  //       setCurrentPosition( c => c - 1 );
  //     }
  //   }
  // }

  // function avanzarVideo () {
  //   if(currentPosition + 1 !== currentWeek.length) {
  //     if(currentWeek[currentPosition + 1]) {
  //       setCurrentPosition( c => c + 1 );
  //     }
  //   } else {
  //     setMostrarVideo(false);
  //   }
  // }

  return (
    <div className="w-full">
      {isLoading ? (
        <div
          className="flex align-items-center justify-content-center"
          style={{ height: '70vh' }}
        >
          <div>
            <Loading></Loading>
            {/* <Container maxWidth="xs">
              Espera un momento por favor, mientras carga el programa
            </Container> */}
          </div>
        </div>
      ) : (
        <>
          {currentWeek && currentWeek.length > 0 ? (
            !matches ? (
              <Fit12PagePC
                currentPosition={currentPosition}
                setCurrentPosition={setCurrentPosition} 
                weeks={weeks}
                currentWeek={currentWeek}
                weekPosition={weekPosition}
                setWeekPosition={setWeekPosition}
              />
            ) : (
              <div
                style={{
                  alignItems: 'center',
                  minHeight: '',
                  position: 'relative',
                  padding: '1rem 1.2rem',
                  left: '-8px',
                }}
                className='w-full'
              >
                <div>
                  <div className="flex items-center mb-4" style={{ gap: '1rem' }}>
                    <img
                      onClick={() => navigate('/')}
                      src={atrasIcon}
                      style={{ width: '35px', height: '25px' }}
                    />
                    <p className="title"> Programa Fit 12 </p>
                  </div>

                  <div className="flex items-end pb-2">
                    {/* <div className="py-[6px] px-2 rounded bg-black text-white">
                      <p className="text-lg font-bold p-0 m-0">Semana:</p>
                    </div> */}
                    <FormControl size="small" fullWidth>
                      <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        style={{ fontSize: '1.1rem' }}
                        value={weekPosition}
                        onChange={(e) => setWeekPosition(e.target.value as number)}>
                        {weeks.map((option, index) => (
                          <MenuItem key={index} value={index}>
                            {option.semana}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>

                  <div className="flex justify-start text-left w-full">
                    <p
                      className="m-0 title mt-2 text-[1rem]"
                      style={{ color: '#5F5F5F', fontWeight: 'semibold' }}
                    >
                      {dataMiniCurso?.titulo ? dataMiniCurso?.titulo : 'Video:'}
                    </p>
                  </div>

                  <div className="flex flex-col gap-4 m-auto">
                    {currentWeek && currentWeek.length > 0 && currentWeek[0].urlVimeoHLS && dataMiniCurso && (
                      <>
                        <div className="mt-4">
                          {!mostrarVideo ? (
                            <div className="relative" style={{ height: '100%' }}>
                              <ContainerButtonPlay
                                onClick={() => {
                                  setMostrarVideo(true);
                                }}
                              >
                                <img src={ grayPlayButton } alt="" width={80} />
                              </ContainerButtonPlay>

                              <img
                                width={'100%'}
                                height={'100%'}
                                src={ dataMiniCurso.portada }
                                alt="portada"
                              />
                            </div>
                          ) : (
                            <VideoPlayer
                              url={ dataMiniCurso.urlVimeoHLS }
                              onEnded={ () => setMostrarVideo(false)}
                            />
                          )}
                        </div>
                        <div className="flex flex-col justify-center items-center">

                          <div
                            className='text-left'
                            dangerouslySetInnerHTML={{ __html: dataMiniCurso?.descripcion || '' }}
                          ></div>
                        </div>
                        {/*//* Navigation Buttons */}
                        {/* <div
                          className="flex items-center justify-center gap-4"
                        >
                          <button
                            className="font-bold m-0 py-2 cursor-pointer text-slate-800 shadow-md rounded-lg bg-[#FDB600] px-[30px] flex items-center gap-1 opacity-95 disabled:opacity-65 hover:opacity-100 disabled:cursor-default"
                            disabled={ currentPosition === 0 ? true : false }
                            onClick={retrocederVideo}
                          >
                            <ArrowBackIosIcon sx={{ fontSize: '10px' }} /> Anterior 
                          </button>

                          <button
                            className={`font-bold m-0 py-2 cursor-pointer text-slate-800 shadow-md rounded-lg bg-[#FDB600] px-[30px] flex items-center gap-1 opacity-95 disabled:opacity-65 hover:opacity-100 disabled:cursor-default`}
                            disabled={currentPosition + 1 === data.length ? true : false}
                            onClick={avanzarVideo}
                          >
                            Siguiente <ArrowForwardIosIcon sx={{ fontSize: '10px' }} />
                          </button>
                        </div> */}
                      </>
                    )}
                  </div>     

                  {/* scroll to bottom float button */}
                  <MiniCursoMenuFab 
                    size='medium'
                    color='warning'
                    // isOpenMenu={isOpenMenu}
                    setIsOpenMenu={setIsOpenMenu}
                  />

                  <MiniCursoMenu
                    currentWeek={currentWeek}
                    isMenuOpen={isOpenMenu}
                    setIsMenuOpen={setIsOpenMenu}
                    videoSelectedID={dataMiniCurso ? dataMiniCurso.miniCursoVideoID : 0}
                    setCurrentPosition={setCurrentPosition}
                  />

                </div>
              </div>
            )
          ) : (
            <div className="mx-1 my-5">Proximamente</div>
          )}
        </>
      )}
    </div>
  );
};

export default Fit12Page;